import * as THREE from "three";
import { setupLights } from "./createLight";

// Scene 생성 및 배경색 설정
export function createScene({ background = 0x0f1115 } = {}) {
  // Scene 생성
  const scene = new THREE.Scene();

  // 기본 배경색 설정 값 파라미터로 받음
  scene.background = new THREE.Color(background);

  // 라이트 설정
  setupLights(scene);

  return scene;
}
